import { render } from "./AlertConfirmation.vue?vue&type=template&id=1ceb24bd"
import script from "./AlertConfirmation.vue?vue&type=script&lang=js"
export * from "./AlertConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__